import { useMutation } from "@/compat/reactQuery";
import actionService from "../../services/actionService";

const useCalculateFormActions = () =>
  useMutation(actionService.calculateActions);

export default useCalculateFormActions;
